import isChromatic from 'chromatic/isChromatic';
import { AccessibleSVG } from '@core/svg';
/**
 * SVG component that displays animated audio bars
 * for "Tap to watch" CTA.
 */
export const PulsingBars = (props) => (<AccessibleSVG width="100%" height="100%" viewBox="0 0 14 14" {...props} style={{ display: 'flex', justifyContent: 'space-between' }}>
    {!isChromatic() ? (<style>
        {`
        @keyframes audioBar {
          0%, 100% { transform: scaleY(1); }
          50% { transform: scaleY(0.5); }
        }
      `}
      </style>) : null}
    <rect x="0" y="0" width="2" height="14" rx="1" fill="currentColor  " style={{
        animation: 'audioBar 1s ease-in-out infinite',
        transformOrigin: 'center',
    }}/>
    <rect x="4" y="0" width="2" height="14" rx="1" fill="currentColor" style={{
        animation: 'audioBar 1s ease-in-out infinite',
        animationDelay: '0.5s',
        transformOrigin: 'center',
    }}/>
    <rect x="8" y="0" width="2" height="14" rx="1" fill="currentColor" style={{
        animation: 'audioBar 1s ease-in-out infinite',
        animationDelay: '0.3s',
        transformOrigin: 'center',
    }}/>
    <rect x="12" y="0" width="2" height="14" rx="1" fill="currentColor" style={{
        animation: 'audioBar 1s ease-in-out infinite',
        animationDelay: '0.7s',
        transformOrigin: 'center',
    }}/>
  </AccessibleSVG>);
